import { useLocation } from "react-router-dom";

import { useLocalizationStore } from "stores/localization";
import { makeLangUrl } from "./makeLangUrl";

export const isArray = (i: unknown): i is any[] => Array.isArray(i);

export const isObject = (i: unknown): i is Record<string, unknown> =>
  typeof i === "object" && i !== null && !Array.isArray(i);

export const isUrlActive = (url: string): boolean => {
  const location = useLocation();

  if (!url) {
    return false;
  }

  const currentUrl = makeLangUrl(url).toLowerCase();
  const fullPath = `${location.pathname}${location.search}`.toLowerCase();
  return decodeURIComponent(fullPath) === currentUrl;
};

export const isUrlInclude = (url: string): boolean => {
  const location = useLocation();
  if (!url) {
    return false;
  }

  const normalizedUrl = url.toLowerCase();
  const fullPath = `${location.pathname}${location.search}`.toLowerCase();

  if (normalizedUrl === "/") {
    return location.pathname === "/";
  }

  return (
    fullPath.includes(normalizedUrl) &&
    !location.pathname.includes("sportsbook")
  );
};

export const isAvailableLang = (lang: string): boolean => {
  const langs = useLocalizationStore.getState().languages;
  return langs.some((l) => l.isoCode.toLowerCase() === lang.toLowerCase());
};
